import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { api } from "@/api/client";

export default function AIStrategyEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) { setError("策略ID缺失"); setLoading(false); return; }
    (async () => {
      try {
        const s = await api.get<any>(`/alpha-lab/strategies/${id}`);
        if (!s || !s.id) { setError("策略未找到"); setLoading(false); return; }
        // Encode strategy data as query params and redirect to create page
        const params = new URLSearchParams();
        params.set("edit", "1");
        params.set("id", String(s.id));
        params.set("name", s.name || "");
        params.set("style", s.style || "balanced");
        params.set("tags", s.tags || "");
        params.set("desc", s.description || "");
        params.set("holdDays", String(s.holdingPeriodDays || 30));
        try {
          const cfg = JSON.parse(s.configParams || "{}");
          if (cfg.stockPool) {
            if (cfg.stockPool.pools) params.set("pools", cfg.stockPool.pools.join(","));
            if (cfg.stockPool.industriesAllow) params.set("sectors", cfg.stockPool.industriesAllow.join(","));
            if (cfg.stockPool.peMin) params.set("peMin", String(cfg.stockPool.peMin));
            if (cfg.stockPool.peMax) params.set("peMax", String(cfg.stockPool.peMax));
            if (cfg.stockPool.totalCapMinYi) params.set("capMin", String(cfg.stockPool.totalCapMinYi));
            if (cfg.stockPool.maxHoldings) params.set("maxHoldings", String(cfg.stockPool.maxHoldings));
          }
          if (cfg.capital) {
            params.set("maxPos", String(cfg.capital.maxSinglePosPct || ""));
            params.set("conc", String(cfg.capital.maxSectorConcPct || ""));
            params.set("cashFloor", String(cfg.capital.cashFloorPct || ""));
          }
          if (cfg.risk) {
            params.set("profitPct", String(cfg.risk.takeProfitPct || ""));
            params.set("lossPct", String(cfg.risk.stopLossPct || ""));
            params.set("maxDD", String(cfg.risk.maxDrawdownPct || ""));
          }
        } catch {}
        navigate(`/ai-strategy/create?${params.toString()}`, { replace: true });
      } catch {
        setError("加载策略失败");
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  return (
    <div className="flex-1 flex items-center justify-center">
      {loading ? (
        <div className="w-5 h-5 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
      ) : (
        <p className="text-sm text-foreground-400">{error}</p>
      )}
    </div>
  );
}
